module.exports = __webpack_public_path__ + "img/awards.2a6f63f4.svg";